class ProductList extends Component {
    constructor(el) {
        super(el);
        this.swiperEl = this.$find('[data-swiper]');
        this.swiperItems = this.$findAll('[data-swiper-item]');
        this.productCategory = document.querySelector('.ProductCategory');
        this.isProductCategory = this.productCategory && this.productCategory.contains(el);
        this.swiper = null;
        this.isSlider = false;
        this.activeClass = 'slider-active';
        this.swiperEl && !this.isProductCategory && this.constructSwiper();
    }

    constructSwiper() {
        this.swiper = new Swiper(this.swiperEl, {
            init: false,
            watchOverflow: true,
            slidesPerView: 1,
            loop: false,
            navigation: {
                nextEl: '[data-product-list-next]',
                prevEl: '[data-product-list-prev]',
            },
            pagination: {
                el: '[data-product-list-pagination]',
                clickable: true
            },
            breakpoints: {
                440: {
                    slidesPerView: 2
                },
                860: {
                    slidesPerView: 3
                },
                1280: {
                    slidesPerView: 4
                },
                1600: {
                    slidesPerView: 5
                }
            }
        });

        this.swiper.on('resize init', instance => {
            this.isSlider = instance.virtualSize > instance.size;
            this.swiperEl.classList.toggle(this.activeClass, this.isSlider);
            this.swiperItems.forEach(item => {
                item.classList.toggle(this.activeClass, this.isSlider);
            });
        });

        this.swiper.init();
    }
}
